import { AsyncReturnType } from "type-fest";

import { CampaignService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CampaignService.createTemplate>[0];
type Data = AsyncReturnType<typeof CampaignService.createTemplate>;
type Error = unknown;

export const useCreateTemplate = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CampaignService.createTemplate,
    options
  );

  return result;
};
